import React from 'react';
import { SponsorDetailModal as CommonSponsorDetailModal } from '@portal/components/sponsors/SponsorDetailModal';
import type { Sponsor } from '../../../types/sponsor.types';

interface SponsorDetailModalProps {
    sponsor: Sponsor;
    isOpen: boolean;
    onClose: () => void;
}

export const SponsorDetailModal: React.FC<SponsorDetailModalProps> = ({ sponsor, isOpen, onClose }) => {
    return (
        <CommonSponsorDetailModal
            sponsor={sponsor}
            isOpen={isOpen}
            onClose={onClose}
            // Public event shows less features
            canDownloadMaterials={false}
            showCategories={true}  // Enable categories for public event
            showBoothLocation={false}
            showSpecialOffers={false}
            showMaterials={false}
            showLastVisited={false}
        />
    );
};